import { module } from 'modujs';
import Croppie from 'croppie';
//const axios = require( 'axios' ).default;

export default class extends module {
    constructor(m) {
        super(m);
        this.fileInput = this.el.querySelector( '[data-file-input]' );
        this.reader = new FileReader();
        this.fileInput.addEventListener( 'change', this.onFileChange.bind( this ) );
        this.reader.addEventListener("load", this.onReaderLoad.bind( this ) );
        this.croppie = new Croppie( this.el.querySelector( '[data-croppie]'), { showZoomer: false, enableExif: true, viewport: {  width: 132, height: 132, type: 'square' } } );

        this.saveBtn = this.el.querySelector( '[data-save]' );
        this.saveBtn.addEventListener( 'click', this.onSave.bind( this ) );

        this.cancelBtn = this.el.querySelector( '[data-cancel]' );
        this.cancelBtn.addEventListener( 'click', this.onCancel.bind( this ) );

        this.form = this.el.querySelector( 'form' );

        ['mouseenter', 'touchstart'].forEach(evt => this.el.querySelector( '[data-croppie]').addEventListener(evt, this.stopScrollbar.bind(this), false));
        ['mouseleave', 'touchend'].forEach(evt => this.el.querySelector( '[data-croppie]').addEventListener(evt, this.startScrollBar.bind(this), false));


        this.onUpdateBind = this.onUpdate.bind( this );
        this.initCroppie();

        this.el.querySelector( '[data-remove]' ).addEventListener( 'click', this.onRemove.bind( this ) );
    }

    initCroppie(){
        if( this.el.classList.contains( 'has-photo') ){
            this.initialSrc = this.el.querySelector( '[data-current-image]' ).src;
            this.el.querySelector( '[data-croppie]').removeEventListener('update', this.onUpdateBind );
            this.croppie.bind({ url: this.initialSrc }).then(() =>{
                this.el.querySelector( '[data-croppie]' ).classList.remove( 'opacity-0' );
                this.el.querySelector( '[data-croppie]').addEventListener('update', this.onUpdateBind );

            });
        }
    }

    onUpdate( e ){
        this.el.classList.add( 'save' );
    }

    onSave(){
        this.el.classList.remove( 'save' );
        this.el.classList.add( 'loading' );
        this.croppie.result({ type: 'canvas', size: { width: 600, height: 600 }, quality: 1, format : 'jpeg' }).then( resp => {
            this.form.querySelector( '[data-input]' ).value = resp;
            axios.post( this.form.getAttribute( 'action' ), new FormData( this.form ), { withCredentials: true } ).then( this.onSuccess.bind( this ) ).catch( this.onError.bind( this ) );
        });
    }

    onCancel(){
        this.el.classList.remove( 'save' );
        this.el.classList.remove( 'loading' );
        if( this.el.classList.contains( 'has-photo') ){
            this.initCroppie();
        } else {
            this.croppie.destroy();
            this.el.querySelector( '[data-croppie]').classList.add( 'opacity-0' );
            this.croppie = new Croppie( this.el.querySelector( '[data-croppie]'), { showZoomer: false, enableExif: true, viewport: {  width: 132, height: 132, type: 'square' } } );
        }


    }

    onRemove(){
        this.el.classList.remove( 'save' );
        this.el.classList.add( 'removing-loading' );
        this.form.querySelector( '[data-input]' ).value = 'remove';
        axios.post( this.form.getAttribute( 'action' ), new FormData( this.form ), { withCredentials: true } ).then( this.onRemoveSuccess.bind( this ) ).catch( this.onError.bind( this ) );
    }

    onRemoveSuccess(){
        this.el.classList.remove( 'removing-loading' );
        this.el.classList.remove( 'has-photo');
        this.onCancel();
        this.call( 'update', '', 'Avatar' );
    }

    onSuccess(){
        this.el.classList.remove( 'loading' );
        setTimeout( () => this.el.classList.add( 'has-photo'), 800 );
        this.call( 'update', this.form.querySelector( '[data-input]' ).value, 'Avatar' );
    }

    onError(){
        this.el.classList.remove( 'loading' );
    }

    onFileChange(){
        if ( this.fileInput.files[0] === undefined ) return;
        this.reader.readAsDataURL(this.fileInput.files[0]);
    }

    onReaderLoad( e ){
        this.fileInput.value = '';
        let imgSrc = e.target.result;
        let image = new Image();
        this.el.classList.remove( 'error' );
        this.call( 'update', false, 'Scroll');
        image.onload = e => {
            let img = e.target;
            if( img.width < 800 ||  img.height < 800 ){
                this.el.classList.add( 'error' );
                this.call( 'update', false, 'Scroll');
            } else {
                this.croppie.bind({ url: imgSrc }).then(() =>{
                    this.el.querySelector( '[data-croppie]').classList.remove( 'opacity-0' );
                    this.el.classList.add( 'save' );
                });
            }
        };
        image.src = e.target.result;
    }

    startScrollBar( e ){
        this.call( 'start', false, 'Scroll' );
    }

    stopScrollbar( e ){
        this.call( 'stop', false, 'Scroll' );
    }
}
